import { createStyles, makeStyles, fade } from '@material-ui/core/styles';
import { WHITE, BLACK } from 'constants/colors';
export default makeStyles(theme => createStyles({
  navigationRoot: {
    flexGrow: 1
  },
  menu: {
    zIndex: 100
  },
  title: {
    flexGrow: 1,
    textAlign: 'left',
    marginLeft: theme.spacing(2)
  },
  nameTitle: {
    [theme.breakpoints.down('xs')]: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  },
  logo: {
    width: '80px',
    height: 'auto'
  },
  list: {
    width: 250
  },
  icon: {
    marginRight: theme.spacing(2)
  },
  language: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    borderTop: `1px solid ${theme.palette.primary.main}`
  },
  text: {
    color: WHITE,
    marginLeft: theme.spacing(1)
  },
  button: {
    boxSizing: 'border-box',
    '&.active': {
      textDecoration: 'underline'
    }
  },
  box: {
    backgroundColor: theme.palette.primary.main
  },
  navigationBox: {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(2, 3, 2, 3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  profileMenu: {
    '& div': {
      width: 200
    }
  },
  navLinks: {
    marginLeft: theme.spacing(1)
  },
  drawerNavLinkActive: {
    backgroundColor: 'rgba(0, 0, 0, 0.09)'
  },
  closeDrawerIcon: {
    padding: theme.spacing(0, 2)
  },
  drawerDivider: {
    backgroundColor: fade(WHITE, 0.35),
    marginBottom: theme.spacing(1)
  },
  navigationProfileBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexGrow: 1,
    textAlign: 'right',
    [theme.breakpoints.down('md')]: {
      padding: 0,
      overflow: 'auto'
    }
  },
  customersBanner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    '& > div': {
      padding: theme.spacing(0.75)
    }
  },
  logoBanner: {
    display: 'flex',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    cursor: 'pointer'
  },
  contactUs: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: BLACK
  },
  hidden: {
    display: 'none'
  }
}));